import fonts from '../../styles/fonts';
import palette from '../../styles/palette';
import position from '../../styles/position';

const styles = {
    wrapper: position.absoluteFill,
    title: {
        ...fonts.title,
        fontSize: 40,
        color: palette.text.primary,
    } as React.CSSProperties,
};
export default styles;